import React, { useEffect, useState, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import EventContext from "./EventContext";

import EventListener from "utils/eventListener";
import { useUser } from "utils/hooks";
import { isLoggedIn } from "utils/misc";

function EventProvider({ children }) {
  const [retry, setRetry] = useState(0);
  const [instance] = useState(() => new EventListener());
  const { token, user } = useUser();
  const ref = useRef();
  const numFails = useRef(0);

  // useEffect(() => {
  //   let reconnectTimeout = null;

  //   if (token && isLoggedIn(user)) {
  //     // Assume it succeeded if there's no error in 5 seconds
  //     const failTimeout = setTimeout(() => {
  //       numFails.current = 0;
  //     }, 5000);

  //     ref.current = new EventSource(`//${process.env.HOST_API}/user/events?token=${token}`)
  //     ref.current.onmessage = (event) => {
  //       try {
  //         const { name, data } = JSON.parse(event.data);
  //         instance.trigger(name, data);
  //       } catch(err) {
  //         console.error("Error while parsing server event", err)
  //       }
  //     }

  //     ref.current.onerror = () => {
  //       numFails.current = numFails.current + 1;
  //       clearTimeout(failTimeout);

  //       // Max 30 seconds
  //       const reconnectWait = Math.min(30000, 1000 + (1000 * numFails.current));

  //       reconnectTimeout = setTimeout(() => {
  //         setRetry(Date.now());
  //       }, reconnectWait);
  //     }

  //     return () => {
  //       ref.current?.close();
  //       if (reconnectTimeout) {
  //         clearTimeout(reconnectTimeout);
  //       }

  //     }
  //   }

  //   return () => {
  //     ref.current?.close();
  //   }
  // }, [token, user, retry, numFails]);

  return (
    <EventContext.Provider value={{ instance }}>
      {children}
    </EventContext.Provider>
  );
}

EventProvider.propTypes = {
  children: PropTypes.any,
};

export default EventProvider;
